/* eslint-disable no-undef */
// userSaga.js
import { call,  put,  takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { PROFILE_CHANGE_REQUEST } from './Constants';
import { profileChangeRequestError, profileChangeRequestSuccess } from './Actions';
import moment from 'moment';
import { Modal } from 'antd';
// import { Modal } from 'antd';



function* profileChange(action) {

    try {    
                
        const id = action.payload.id;

        let isint;
        if ( action.payload.residence === 'India') {
            isint = false;
        } else {
            isint = true;
        }
        
        const urll = `${process.env.REACT_APP_API_BASE_URL}/patients/${id}`;

        const headers ={
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
        

        let data = {
            isPrimaryDetailsUpdated: action.payload.isPrimaryDetailsUpdated,
            updatedFirstName: action.payload.firstname,
            updatedLastName: action.payload.lastname,
            primaryContact: action.payload.contact,
            secondaryContact: action.payload.altNumber,
            address: action.payload.address,
            residentCountry: action.payload.residence,
            updatedInitials: action.payload.initials,
            updatedGender: action.payload.gender,
            isInternational: isint,
            bloodGroup: action.payload.bloodGroup,
            updatedDob: action.payload.dob ? moment(action.payload.dob, 'YYYY-MM-DD').format('YYYY-MM-DD') : null,
        };        
        
        const response = yield call(axios.patch, urll, data, { headers});
                
        if (response.status === 200 || response.status === 201) {
 
            if(action.payload.image) {

                const file = action.payload.image;
                const image = new FormData();
                image.append('uri', file);
                image.append('permissions', 'patient');
                image.append('id', id);
                const urlFile = `${process.env.REACT_APP_API_BASE_URL}/uploads`;
                
                data = image;
                // const headers = new Headers({

                //     Authorization: sessionStorage.jwt,
                //     'api-header-security': process.env.REACT_APP_API_HEADER_SECURITY,
                // });

                delete headers['Content-Type'];                
            
                const response = yield call(axios.post, urlFile, data, { headers});
            
                if(response.status == 200 || response.status == 201) {
                    if(action.payload.isPrimaryDetailsUpdated == true) {
                        Modal.warning({
                            title: 'Your profile changes has been send to admin for verification.',
                        });
                    } else {
                        Modal.success({
                            title: 'Profile updated successfully',
                        });
                    }
                    yield put(profileChangeRequestSuccess('success'));

                }
            } else {
                if(action.payload.isPrimaryDetailsUpdated == true) {
                    Modal.warning({
                        title: 'Your profile changes has been send to admin for verification.',
                    });
                } else {
                    Modal.success({
                        title: 'Profile updated successfully',
                    });
                }
                yield put(profileChangeRequestSuccess('success'));
            }

        } else {
            // Dispatch the failure action with the response message
            yield put(profileChangeRequestError('An error occurred.'));
        }
    } catch (error) {        
        yield put(profileChangeRequestError('An error occurred.'));
        // yield put(prescriptionRequestError('An error occurred.'));
    }

}



// Watcher Saga
export function* watchFetchMyProfile() {
    yield takeEvery(PROFILE_CHANGE_REQUEST, profileChange);
}
